import React, { useState, useEffect } from 'react';

export const Toast = ({ message, duration = 2000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // For 2-second duration: visible for 1.7s, fade for 0.3s
    // For longer durations: fade starts 300ms before end
    const fadeStartTime = duration - 300;
    
    const fadeTimer = setTimeout(() => {
      setIsVisible(false);
    }, fadeStartTime);
    
    const removeTimer = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [duration, onClose]);

  return (
    <div
      className={`fixed top-4 left-1/2 transform -translate-x-1/2 transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      style={{ zIndex: 9999 }}
    >
      <div className="bg-white shadow-lg rounded-lg p-4 flex items-center justify-center min-w-[320px]">
        <p className="text-gray-900 font-semibold" style={{ fontSize: '16.8px' }}>{message}</p>
      </div>
    </div>
  );
};

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, duration = 2000) => {
    const id = Date.now();
    // Clear all existing toasts and show only the new one
    // This ensures only one toast is visible at a time
    setToasts([{ id, message, duration }]);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const ToastContainer = () => (
    <>
      {toasts.map((toast, index) => (
        <div key={toast.id}>
          <Toast
            message={toast.message}
            duration={toast.duration}
            onClose={() => removeToast(toast.id)}
          />
        </div>
      ))}
    </>
  );

  return { showToast, ToastContainer };
};
